import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { openModal } from "../builder/save-changes";
import EmailSendingBanner from "../components/EmailSendingBanner";
import AutomationCard from "./AutomationCard";

const PanelActions = ({ product }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <div className="ea-actions">
      <button
        type="button"
        data-button-type="secondary"
        onClick={() => openModal("automationTemplates", { product })}
      >
        {t("emailAutomations.panel.startFromTemplate")}
      </button>
      <button
        type="button"
        data-button-type="primary"
        onClick={() => openModal("newAutomation", { product })}
      >
        <SvgIcon
          src="/img/new-icons/add.svg"
          useCurrentColor
          classNames="icon-sm"
        />
        {t("emailAutomations.panel.newAutomation")}
      </button>
    </div>
  );
};

PanelActions.propTypes = { product: PropTypes.string.isRequired };

const EmptyState = ({ product, templateCount }) => {
  const { t } = useTranslation("coaching-portal");
  const body =
    ["push", "pull"].includes(product) && templateCount
      ? t(`emailAutomations.empty.bodies.${product}`, { count: templateCount })
      : t("emailAutomations.empty.body");
  return (
    <div className="ea-empty">
      <span className="ea-empty__icon" aria-hidden="true">
        <img src="/img/new-icons/automation-flow.svg" alt="" />
      </span>
      <h4 className="ea-empty__title">{t("emailAutomations.empty.title")}</h4>
      <p className="ea-empty__body">{body}</p>
      <PanelActions product={product} />
    </div>
  );
};

EmptyState.propTypes = {
  product: PropTypes.string.isRequired,
  templateCount: PropTypes.number,
};

// The Email Automations of one product: the state of the sending domain and the list
const EmailAutomationsPanel = ({
  product,
  automations,
  filterOptions,
  sendingSettings,
  templateCount,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <section className="ea-panel">
      <header>
        <hgroup>
          <h4 className="ea-panel__title">
            {t("emailAutomations.panel.title")}
          </h4>
          <p className="ea-panel__subtitle">
            {t(`emailAutomations.panel.subtitles.${product}`, {
              defaultValue: t("emailAutomations.panel.subtitle"),
            })}
          </p>
        </hgroup>
        <PanelActions product={product} />
      </header>
      <EmailSendingBanner settings={sendingSettings} />
      {automations === null ? (
        <p className="ea-hint">{t("emailAutomations.errors.loadFailed")}</p>
      ) : null}
      {automations?.length === 0 ? (
        <EmptyState product={product} templateCount={templateCount} />
      ) : null}
      {automations?.length > 0 ? (
        <div className="ea-grid">
          {automations.map((automation) => (
            <AutomationCard
              key={automation.id}
              automation={automation}
              options={filterOptions}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
};

EmailAutomationsPanel.propTypes = {
  product: PropTypes.string.isRequired,
  automations: PropTypes.array,
  filterOptions: PropTypes.object,
  sendingSettings: PropTypes.object,
  templateCount: PropTypes.number,
};

export default EmailAutomationsPanel;
